import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CustomerAuthProvider } from './context/CustomerAuthContext';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/toaster';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import CategoryPage from './pages/CategoryPage';
import ProductDetail from './pages/ProductDetail';
import Contact from './pages/Contact';
import Orario from './pages/Orario';
import DatiFiscali from './pages/DatiFiscali';
import Pagamenti from './pages/Pagamenti';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Cart from './pages/Cart';
import CustomerLogin from './pages/CustomerLogin';
import CustomerRegister from './pages/CustomerRegister';
import CustomerProfile from './pages/CustomerProfile';
import { ForgotPassword, ResetPassword, ConfirmChangePassword } from './pages/PasswordPages';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CustomerAuthProvider>
            <CartProvider>
              <Navbar />
              <main className="min-h-[60vh]">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/noleggio" element={<Catalog />} />
                  <Route path="/categoria/:slug" element={<CategoryPage />} />
                  <Route path="/prodotto/:slug" element={<ProductDetail />} />
                  <Route path="/carrello" element={<Cart />} />
                  <Route path="/contatti" element={<Contact />} />
                  <Route path="/orario" element={<Orario />} />
                  <Route path="/dati-fiscali" element={<DatiFiscali />} />
                  <Route path="/pagamenti" element={<Pagamenti />} />
                  <Route path="/cliente/login" element={<CustomerLogin />} />
                  <Route path="/cliente/registrati" element={<CustomerRegister />} />
                  <Route path="/cliente/profilo" element={<CustomerProfile />} />
                  <Route path="/cliente/password-dimenticata" element={<ForgotPassword scope="customer" />} />
                  <Route path="/admin" element={<AdminLogin />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/admin/password-dimenticata" element={<ForgotPassword scope="admin" />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/conferma-cambio-password" element={<ConfirmChangePassword />} />
                </Routes>
              </main>
              <Footer />
              <Toaster />
            </CartProvider>
          </CustomerAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
